/** Mirrors the backend's SubscriptionStatus enum values. */
export enum SubscriptionStatusEnum {
  PENDING_PAYMENT = 'pending_payment',
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}
